module.exports = __webpack_public_path__ + "static/img/jewellery_home_wedding_ring.6056ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/jewellery_home_wedding_ring.png
// module id = 7X4j
// module chunks = 0